import React from "react";
import { Card, CardContent, Typography, Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import VerifiedIcon from "@mui/icons-material/Verified";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default function ProjectCard({ project, onClick }) {
  // const navigate = useNavigate();

  return (
    <Card
      onClick={onClick ? () => onClick(project) : null}
      sx={{
        cursor: "pointer",
        borderRadius: 2,
        position: "relative",

        /* GLASS EFFECT */
        background: "rgba(255, 255, 255, 0.06)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: "1px solid rgba(255,255,255,0.12)",

        /* BASE SHADOW */
        boxShadow: "0 8px 24px rgba(0,0,0,0.25)",

        /* GLOW ON TAP / CLICK */
        transition: "all 0.2s ease-in-out",
        "&:active": {
          boxShadow:
            "0 0 0 2px rgba(34,197,94,0.6), 0 0 18px rgba(34,197,94,0.7)",
          transform: "scale(0.98)",
        },
      }}
    >
      <CardContent
        sx={{
          p: 1.2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* HEADER */}
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{
              color: "primary.main",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {project.project_name}
          </Typography>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {project.customer_name}
          </Typography>
        </Box>

        {/* DETAILS */}
        <Box>
          <Typography
            variant="caption"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {project.poc}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="caption"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {project.district}
          </Typography>
        </Box>

        {/* FOOTER */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "70%",
            }}
          >
            {dayjs(project.created_at).fromNow()}
          </Typography>

          <Stack direction="row" spacing={0.5}>
            {project.paymentVerified ? (
              <VerifiedIcon sx={{ fontSize: 16, color: "success.main" }} />
            ) : (
              <HourglassEmptyIcon sx={{ fontSize: 16, color: "error.main" }} />
            )}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}
